import React from 'react'

import BottomNavigation from '../BottomNavigation/BottomNavigation'
import Header from '../Header/Header'

import { ContentWrap } from './styled'

type LayoutProps = {
  withInvite?: boolean
}

const Layout: React.FC<LayoutProps> = ({ children, withInvite }) => (
  <>
    <Header withInvite={withInvite} />
    <ContentWrap>{children}</ContentWrap>
    <BottomNavigation />
  </>
)

export default Layout
